/**
 * check if element exists
 * @param {dom-element} el
 *
 * @return {boolean}
 */
export function getElementExists(el) {
  return el && typeof el !== "undefined" && el !== null;
}

/**
 * get parent element by classname
 * @param {dom-element} el
 * @param {string} cls
 *
 * @return {dom-element} el
 */
export function getParentByClass(el, cls) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    !el.classList.contains(cls)
  );
  return el;
}

/**
 * get parent element by data attribute
 * @param {dom-element} el
 * @param {string} attribute
 *
 * @return {dom-element} el
 */
export function getParentByDataAttribute(el, attribute) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    !el.hasAttribute(attribute)
  );
  return el;
}

/**
 * Gets the parent of an element by tag
 *
 * @param  {dom-element} el
 * @param  {string} tagName
 * @return {dom-element}
 */
export function getParentByTag(el, tagName) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.tagName.toLowerCase() != tagName.toLowerCase()
  );
  return el;
}

/**
 * Gets the parent of an element by ID
 *
 * @param  {dom-element} el
 * @param  {string} id
 * @return {dom-element}
 */
export function getParentById(el, id) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.id != id
  );
  return el;
}

/**
 * Gets the parent of an element by attribute-value
 *
 * @param  {dom-element} el
 * @param  {string} attr
 * @param  {string} value
 * @return {dom-element}
 */
export function parentByAttributeValue(el, attr, value) {
  while (
    (el =
      el instanceof SVGElement
        ? el.parentNode
        : typeof jQuery !== "undefined" && el instanceof jQuery
        ? el[0].parentElement
        : el.parentElement) &&
    el.getAttribute(attr) != value
  );
  return el;
}
/**
 * Get translate3D values of element
 *
 * @param {dom-element} el
 */
export function getCssTranslate3D(el) {
  // returns matrix(1,0,0,1,0,0)
  const translate = { x: 0, y: 0, z: 0 };
  const matrix = window.getComputedStyle(el).transform;

  if (matrix != "none") {
    const matrixArray = matrix.replace("matrix(", "").split(",");
    // var scaleX = parseFloat(matrixArray[0]);
    // var scaleY = parseFloat(matrixArray[3]);
    // bonus round - gets translate values
    translate["x"] = parseFloat(matrixArray[4]);
    translate["y"] = parseFloat(matrixArray[5]); // parseFloat ignores ")"
  }

  return translate;
}

export function getCssScale(el) {
  // returns matrix(1,0,0,1,0,0)
  let scale = 1;
  const matrix = window.getComputedStyle(el).transform;

  if (matrix != "none") {
    const matrixArray = matrix.replace("matrix(", "").split(",");
    scale = parseFloat(matrixArray[0]); // scaleX
    // let scaleY = parseFloat(matrixArray[3]);
    // let translateX = parseFloat(matrixArray[4]);
    // let translateY = parseFloat(matrixArray[5]); // parseFloat ignores ")"
  }

  return scale;
}

/**
 * Checks if an full element is in viewport
 *
 * @param {dom-element} el
 */
export function isInViewport(el) {
  const bounding = el.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Checks if an part of the element is in viewport
 *
 * @param {dom-element} el
 */
export function isPartOfViewport(el) {
  const bounding = el.getBoundingClientRect();
  return (
    bounding.bottom >= 0 &&
    bounding.top <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.left >= 0 &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Checks if an element is in the center of viewport
 *
 * @param {dom-element} el
 */
export function isInViewportCenter(el) {
  const bounding = el.getBoundingClientRect();
  const vieportHeight =
    window.innerHeight || document.documentElement.clientHeight;

  return (
    bounding.top <= vieportHeight / 2 &&
    bounding.left >= 0 &&
    bounding.bottom >= vieportHeight / 2 &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Check browser support of single css property
 * @param {string} property
 * @return {boolean}
 */
export function isCSSPropertySupported(property) {
  return property in document.body.style;
}

/**
 * Check if the paramater is a function
 * @param {function} functionToCheck
 * @return {boolean}
 */
export function isFunction(functionToCheck) {
  return (
    functionToCheck && {}.toString.call(functionToCheck) === "[object Function]"
  );
}

/**
 * Set browser cookie with execurion date
 * @param {string} cname
 * @param {string} cvalue
 * @param {string} exdays
 * @param {string} domain
 */
export function setCookie(cname, cvalue, exdays, domain = globalvars["host"]) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie =
    cname + "=" + cvalue + ";" + expires + ";domain=" + domain + ";path=/;";
}

/**
 * Get single cookie
 * @param {string} cname
 */
export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/**
 * Delete single cookie
 * @param {string} cname
 * @param {string} domain
 */
export function deleteCookie(cname, domain = globalvars["host"]) {
  document.cookie =
    cname +
    "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" +
    domain +
    "; path=/;";
}

/**
 * IE10 classList support
 * Method that checks whether cls is present in element object.
 * @param  {Object} ele DOM element which needs to be checked
 * @param  {Object} cls Classname is tested
 * @return {Boolean} True if cls is present, false otherwise.
 */
export function hasClass(ele, cls) {
  return (
    ele.hasAttribute("class") && ele.getAttribute("class").indexOf(cls) > -1
  );
}

/**
 * Method that adds a class to given element.
 * @param  {Object} ele DOM element where class needs to be added
 * @param  {Object} cls Classname which is to be added
 * @return {null} nothing is returned.
 */
export function addClass(ele, cls) {
  if (typeof ele !== "undefined" && ele !== null) {
    if (ele.classList) {
      ele.classList.add(cls);
    } else if (!hasClass(ele, cls)) {
      ele.setAttribute("class", ele.getAttribute("class") + " " + cls);
    }
  }
}

/**
 * Method that does a check to ensure that class is removed from element.
 * @param  {Object} ele DOM element where class needs to be removed
 * @param  {Object} cls Classname which is to be removed
 * @return {null} Null nothing is returned.
 */
export function removeClass(ele, cls) {
  if (typeof ele !== "undefined" && ele !== null) {
    if (ele.classList) {
      ele.classList.remove(cls);
    } else if (hasClass(ele, cls)) {
      ele.setAttribute("class", ele.getAttribute("class").replace(cls, " "));
    }
  }
}

/**
 * Get Element offset in page
 * @param {Element} el
 * @return {Object}
 * Access: el.left, el.top
 */
export function getOffset(el) {
  var _x = 0;
  var _y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    _x += el.offsetLeft - el.scrollLeft;
    _y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: _y, left: _x };
}

/**
 * PERFORMANCE
 * Method to set all event listener passive by default
 * to speedup in modern browsers
 *
 * Source: https://github.com/zzarcon/default-passive-events/blob/master/dist/index.js
 * Explainer: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 * alternative Polyfill: https://github.com/WICG/EventListenerOptions/blob/gh-pages/EventListenerOptions.polyfill.js
 *
 * e.g. window.addEventListener("scroll", function () {}, { passive: true });
 */
export function setPassiveEventListeners() {
  var e,
    t = [
      "scroll",
      "wheel",
      "touchstart",
      "touchmove",
      "touchenter",
      "touchend",
      "touchleave",
      "mouseout",
      "mouseleave",
      "mouseup",
      "mousedown",
      "mousemove",
      "mouseenter",
      "mousewheel",
      "mouseover",
    ];
  if (
    (function () {
      var e = !1;
      try {
        var t = Object.defineProperty({}, "passive", {
          get: function () {
            e = !0;
          },
        });
        window.addEventListener("test", null, t),
          window.removeEventListener("test", null, t);
      } catch (e) {}
      return e;
    })()
  ) {
    var o = EventTarget.prototype.addEventListener;
    (e = o),
      (EventTarget.prototype.addEventListener = function (o, r, n) {
        var s,
          a = "object" == typeof n && null !== n,
          i = a ? n.capture : n;
        ((n = a
          ? (function (e) {
              var t = Object.getOwnPropertyDescriptor(e, "passive");
              return t && !0 !== t.writable && void 0 === t.set
                ? Object.assign({}, e)
                : e;
            })(n)
          : {}).passive =
          void 0 !== (s = n.passive) ? s : -1 !== t.indexOf(o) && !0),
          (n.capture = void 0 !== i && i),
          e.call(this, o, r, n);
      }),
      (EventTarget.prototype.addEventListener._original = e);
  }
}

/**
 * Returns string optimized for url or css class
 * @param {string} value
 * @return {string} value
 */
export function getUrlLabel(value) {
  value = value.toLowerCase();
  value = value.replace(/ä/g, "ae");
  value = value.replace(/ö/g, "oe");
  value = value.replace(/ü/g, "ue");
  value = value.replace(/ß/g, "ss");
  value = value.replace(/ /g, "-");
  value = value.replace(/\./g, "");
  value = value.replace(/,/g, "");
  value = value.replace(/\(/g, "");
  value = value.replace(/\)/g, "");
  return value;
}

/**
 * Function to watch mouse wheel stops
 * @param {dom} element
 * @param {function} callback
 * @param {int} timeout
 * @returns
 */
export function createWheelStopListener(element, callback, timeout) {
  var handle = null;
  var onScroll = function () {
    if (handle) {
      clearTimeout(handle);
    }
    handle = setTimeout(callback, timeout || 200); // default 200 ms
  };
  element.addEventListener("wheel", onScroll);
  return function () {
    element.removeEventListener("wheel", onScroll);
  };
}

/**
 * Smooth scroll to element with ID
 * @param {string} id
 * @param {int} offset
 * @returns
 */
export function scrollToID(id, offset = 0) {
  const target = document.getElementById(id);

  if (!target) return;

  window.scrollTo({
    top: target.offsetTop + offset,
    behavior: "smooth",
  });
}

/**
 * Fade in element
 */
export function fadeOut(element) {
  if (!element) return;
  let op = 1; // initial opacity
  let timer = setInterval(function () {
    if (op <= 0.1) {
      clearInterval(timer);
      element.style.display = "none";
    }
    element.style.opacity = op;
    element.style.filter = "alpha(opacity=" + op * 100 + ")";
    op -= op * 0.1;
  }, 50);
}

/**
 * Fade out element
 */
export function fadeIn(element, display = "block") {
  if (!element) return;
  let op = 0.1; // initial opacity
  element.style.display = display;
  let timer = setInterval(function () {
    if (op >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = op;
    element.style.filter = "alpha(opacity=" + op * 100 + ")";
    op += op * 0.1;
  }, 10);
}
